export const LIST_NAME_MAX_CHARS = 64;
